import React from "react";
import { Relative } from "../../BuildingBlocks/Relative";
import { CRMRoadblockStatusLabelFromForm } from "../CRMRoadblockStatusLabel/CRMRoadblockStatusLabel";
import { Absolute } from "../../BuildingBlocks/Absolute";
import { useHover } from "../../../hooks/useHover";
import { CRMRoadblockStatusLabelPopoverCancelled } from "./CRMRoadblockStatusLabelPopoverCancelled";
import { CRMRoadblockStatusLabelPopoverBlocked } from "./CRMRoadblockStatusLabelPopoverBlocked";
import { CRMRoadblockStatusLabelPopoverResolved } from "./CRMRoadblockStatusLabelPopoverResolved";
import { AnimationPopout } from "../../BuildingBlocks/AnimationPopout";
import { TRoadblockDetailView } from "../../../models/RoadblockDetailView";

type TRoadblockStatusLabelPopoverProps = {
    view: TRoadblockDetailView;
    onClick?: () => void;
};

export const CRMRoadblockStatusLabelPopover = (props: TRoadblockStatusLabelPopoverProps): JSX.Element => {

    const [ref, isHovering] = useHover<HTMLDivElement>({});

    const status = props.view.status;

    const isSuspended = status === "suspended";
    const isBlocked = status === "blocked";
    const isResolved = status === "resolved";

    return (
        <Relative
            divRef={ref}
            width="fit-content"
        >
            {/* PILL */}
            <CRMRoadblockStatusLabelFromForm
                view={props.view}
                onClick={props.onClick}
            />

            {/* POPOVER */}
            {isHovering &&
                <Absolute
                    right="0"
                    top="26px"
                    width="313px"
                >
                    <AnimationPopout>
                        {/* CANCELLED */}
                        {isSuspended &&
                            <CRMRoadblockStatusLabelPopoverCancelled />
                        }

                        {/* BLOCKED */}
                        {isBlocked &&
                            <CRMRoadblockStatusLabelPopoverBlocked view={props.view} />
                        }

                        {/* RESOLVED */}
                        {isResolved &&
                            <CRMRoadblockStatusLabelPopoverResolved view={props.view} />
                        }
                    </AnimationPopout>
                </Absolute>
            }
        </Relative>
    );
};
